/**
 * Mirrors of the caps `AnnouncementMediaService` enforces. Stated in the UI up
 * front AND checked before upload: a marketer exporting a 4 MB WebP from Figma
 * should learn about the ceiling while the file picker is still open, not after
 * pushing the bytes over a phone connection to be rejected.
 *
 * These are MIRRORS, not the source of truth — the API rejects independently, and
 * its message is what the form renders when it does.
 *
 * Their own module rather than the form's: the block editor checks the same caps
 * on a picked file, and reaching them through `announcement-form-utils` — which
 * imports the block validator — would close an import cycle.
 */
export const IMAGE_MAX_BYTES = 3 * 1024 * 1024
export const VIDEO_MAX_BYTES = 20 * 1024 * 1024
export const IMAGE_MAX_LONGEST_EDGE_PX = 4096

export const IMAGE_ACCEPT = 'image/webp'
export const VIDEO_ACCEPT = 'video/mp4,video/webm'

export const formatBytesLimit = (bytes: number): string => `${Math.round(bytes / (1024 * 1024))} MB`

/**
 * The half of the media contract that can be checked without decoding the file.
 * Dimensions are NOT checked here — reading them needs an image decoder, so the
 * longest-edge rule is stated in the UI and enforced by the API.
 */
export const validateMediaSize = (
  file: File | null,
  maxBytes: number,
  label: string,
): string | null => {
  if (file === null || file.size <= maxBytes) {
    return null
  }

  return `${label} is ${Math.round(file.size / 1024)} KB; the limit is ${formatBytesLimit(maxBytes)}.`
}
